// For Add Item to Cart
export const addCart = (product) =>{
    return {
        type:"ADDITEM",
        payload:product
    }
}

// For Delete Item to Cart
export const delCart = (product) =>{
    return {
        type:"DELITEM",
        payload:product
    }
}

// Cart sidebar UI
export const openCart = () => {
    return {
        type: "OPEN_CART",
    }
}

export const closeCart = () => {
    return {
        type: "CLOSE_CART",
    }
}

export const toggleCart = () => {
    return {
        type: "TOGGLE_CART",
    }
}
